import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAccessRequest, IFeedback } from 'src/app/common/model/feedback.model';
import { ISibasiHTTPResponse } from 'src/app/common/model/sibasiHTTPResponse.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  feedbackData!: IFeedback;
  constructor(private http: HttpClient) {}

  public sendFeedback(feedback: IFeedback): Observable<ISibasiHTTPResponse<IFeedback>> {
    return this.http.post<ISibasiHTTPResponse<IFeedback>>(
      `${environment.api_url}feedback`,
      feedback
    );
  }
  public getAllFeedback(): Observable<ISibasiHTTPResponse<[]>> {
    return this.http.get<ISibasiHTTPResponse<[]>>(`${environment.api_url}feedback/all/`);
  }
  public getFeedbackById(feedbackId: string): Observable<ISibasiHTTPResponse<IFeedback>> {
    return this.http.get<ISibasiHTTPResponse<IFeedback>>(
      `${environment.api_url}feedback/one/${feedbackId}`
    );
  }
  public getAllUnactionedFeedback(): Observable<ISibasiHTTPResponse<IFeedback[]>> {
    return this.http.get<ISibasiHTTPResponse<IFeedback[]>>(
      `${environment.api_url}feedback/notActioned`
    );
  }
  public actionFeedback(itemId: string): Observable<ISibasiHTTPResponse<IFeedback[]>> {
    return this.http.get<ISibasiHTTPResponse<IFeedback[]>>(
      `${environment.api_url}feedback/isActioned/${itemId}`
    );
  }

  public getNonActionedFeedback(): Observable<ISibasiHTTPResponse<IFeedback>> {
    return this.http.get<ISibasiHTTPResponse<IFeedback>>(
      `${environment.api_url}feedback/notActioned`
    );
  }

  public sendAccessRequest(
    accessRequest: IAccessRequest
  ): Observable<ISibasiHTTPResponse<IAccessRequest>> {
    return this.http.post<ISibasiHTTPResponse<IAccessRequest>>(
      `${environment.api_url}monival/org/new/user/req`,
      accessRequest
    );
  }
}
